import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_widget_ext_RowClass, bl_cms_widget_hdr_RowClass} from '../../../dbschema';


export class WidgetContainerModel extends BaseContainerModel {

  bl_cms_widget_hdr: bl_cms_widget_hdr_RowClass = new bl_cms_widget_hdr_RowClass();
  bl_cms_widget_ext: bl_cms_widget_ext_RowClass[] = [];
}
